import React from 'react';
import Bredcrumb from '../../Bredcrumb/Main';
import BGImg from "../../../assets/images/bread_crumb_bg.png";  // Default background image
import Review from './ChildSafetyText';  // Updated component with Child Safety content

const Main = () => {
    return (
        <>
            {/* Display breadcrumb with correct title */}
            <Bredcrumb no={1} title="Child Safety Standards" tag="Child Safety" bgimg={BGImg} />

            {/* Child Safety Policy content */}
            <Review />
        </>
    );
}

export default Main;
